import React from 'react';
import styled from 'styled-components';

// Import helpers
import { getTimeLineFormat } from 'helpers/time';
import { EVENTS_NAMES } from 'helpers/variables';

// Import components
import { useContextProvider } from 'components/views/vod/components/PlayerWrapper/useContextProvider';

// Import utilities
import { useEventListener } from 'components/utilities';

const PlayerTimer = () => {
	const [time, setTime] = React.useState('00:00:00');
	const { video } = useContextProvider();

	useEventListener(
		EVENTS_NAMES.TIMEUPDATE,
		() => setTime(getTimeLineFormat(video.currentTime)),
		video
	);

	return <Timer>{time}</Timer>;
};

const Timer = styled.span`
	width: 6rem;
	height: 4rem;
	padding: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 1.9rem;
	padding-bottom: .3rem
	color: ${({ theme }) => theme.player.grayLight};
`;

export default PlayerTimer;
